.asset-index-wrap{
  height: 46px;
  display: flex;
  align-items: center;
  list-style: none;
  padding: 0;
  margin: 0;
  border-bottom: 1px solid #262d40;
  & > li{
    padding: 0 12px;
    white-space: nowrap;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    border-right: 1px solid #262d40;
    &:first-child{
      padding: 0 1rem 0 1.25rem;
      .btn{padding: 0 !important;margin-left: 10px;}
    }
    &:last-child{
      border:none;
    }
  }
  .symbol{
    font-size: 14px;
  }
}
